<!-- Ported from the Polaris kit: src/components/ui/avatar/AvatarFallback.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { AvatarFallback } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  delayMs: { type: Number, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <AvatarFallback
    data-slot="avatar-fallback"
    v-bind="delegatedProps"
    :class="
      cn(
        'bg-polaris-muted flex size-full items-center justify-center rounded-full',
        props.class
      )
    "
  >
    <slot />
  </AvatarFallback>
</template>
